<template>
  <div class="page-content">
    <div class="administrador-heading">
      <h5>{{ $t("lang.admin.add_user.page_title") }}</h5>
    </div>
    <div class="centros-formbg">
      <h6>{{ $t("lang.admin.add_user.add_company_user_title") }}</h6>
      <div class="centros-form">
        <div v-if="errors.length && !success.show">
          <b>{{ $t("lang.admin.device_form.error_list_title") }}</b>
          <div class="alert alert-danger" role="alert">
            <ul style="list-style-type: circle;margin: 10px">
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
        </div>
        <div v-show="success.show">
          <div class="alert alert-success" role="alert">
            {{ success.message }}
          </div>
        </div>

        <form>
          <div class="form-row d-flex align-items-end">
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.admin.add_user.labels.first_name')"
                outlined
                v-model="input.first_name"
              ></v-text-field>
            </div>
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.admin.add_user.labels.last_name')"
                outlined
                v-model="input.last_name"
              ></v-text-field>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.admin.add_user.labels.email')"
                outlined
                v-model="input.email"
              ></v-text-field>
            </div>
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.admin.add_user.labels.password')"
                outlined
                type="password"
                v-model="input.password"
              ></v-text-field>
            </div>
          </div>
          <div class="form-row">
            <div class="select-box col-md-6">
              <v-select
                v-model="input.company"
                :items="companies"
                :menu-props="{ maxHeight: '400' }"
                :label="$t('lang.admin.add_user.labels.company')"
                item-text="name"
                item-value="id"
                outlined
                persistent-hint
              ></v-select>
            </div>
          </div>
          <div class="form-row">
            <div class="mb-0 col-md-12">
              <v-btn type="reset" @click="$router.back()" text rounded>{{
                $t("lang.admin.add_user.btn_cancel")
              }}</v-btn>
              <bx-btn color="primary" @click="submitForm">{{
                $t("lang.admin.add_user.btn_done")
              }}</bx-btn>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
let Input = () => {
  return {
    first_name: null,
    last_name: null,
    email: null,
    password: null,
    company: null,
  };
};

export default {
  name: "AddUserForm",
  data() {
    return {
      input: new Input(),
      errors: [],
      companies: [],
      success: { show: false, message: this.$t("lang.admin.add_user.success") },
      errorLabels: {
        first_name: this.$t("lang.admin.add_user.errors.first_name"),
        last_name: this.$t("lang.admin.add_user.errors.last_name"),
        email: this.$t("lang.admin.add_user.errors.email"),
        password: this.$t("lang.admin.add_user.errors.password"),
        company: this.$t("lang.admin.add_user.errors.company"),
        failed: this.$t("lang.admin.add_user.errors.failed")
      }
    };
  },
  async mounted() {
    this.companies = await this.$api.company.list();
  },
  methods: {
    getCompanyName(id) {
      return this.companies.find(item => item.id === parseInt(id)).name;
    },
    selectCompany(e) {
      if (!this.input.company.includes(e.target.value)) {
        this.input.company.push(e.target.value);
      }
    },
    async submitForm() {
      let input = Object.assign({}, this.input);
      if (this.validate()) {
        try {
        console.log(input)
        let response = await this.$api.company.add(input);
        this.input = new Input();
        this.success.show = true;
        } catch (error) {
          this.errors.push(this.errorLabels.failed);
          console.error(error);
        }
      }
    },
    validate() {
      this.errors = [];
      this.success.show = false;

      let error = false;

      if (!this.input.first_name) {
        error = true;
        this.errors.push(this.errorLabels.first_name);
      }

      if (!this.input.last_name) {
        error = true;
        this.errors.push(this.errorLabels.last_name);
      }

      if (!this.input.email) {
        error = true;
        this.errors.push(this.errorLabels.email);
      }

      if (this.input.company === null) {
        error = true;
        this.errors.push(this.errorLabels.company);
      }

      if (!this.input.password) {
        error = true;
        this.errors.push(this.errorLabels.password);
      }

      if (error) {
        return false;
      }

      return true;
    }
  },
};
</script>
